const TrustedCompaniesSection = () => {

  // Remove specific company logos as requested

  return (
    <section className="py-20 bg-gradient-to-br from-secondary-50 to-primary-50 overflow-hidden" id="main">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Trusted by <span className="bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">thousands of learners</span>
          </h2>
          <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
            Join our community of successful professionals who have transformed their careers through AI testing mastery
          </p>
        </div>

        {/* Success Stats */}
        <div className="text-center">
          <p className="text-lg text-secondary-600 mb-6">
            Our AI testing courses have empowered professionals to advance their careers across the industry
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-secondary-500">
            <span className="flex items-center gap-2 bg-white/50 px-3 py-2 rounded-full backdrop-blur-sm">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              <span className="font-medium">95% completion rate</span>
            </span>
            <span className="flex items-center gap-2 bg-white/50 px-3 py-2 rounded-full backdrop-blur-sm">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" />
              <span className="font-medium">85% career advancement</span>
            </span>
            <span className="flex items-center gap-2 bg-white/50 px-3 py-2 rounded-full backdrop-blur-sm">
              <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse" />
              <span className="font-medium">Industry certifications</span>
            </span>
          </div>
        </div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-primary-200 rounded-full opacity-20 animate-float" />
      <div className="absolute bottom-20 right-20 w-16 h-16 bg-purple-200 rounded-full opacity-20 animate-float" style={{ animationDelay: '2s' }} />
      <div className="absolute top-1/2 left-1/4 w-12 h-12 bg-secondary-200 rounded-full opacity-20 animate-float" style={{ animationDelay: '4s' }} />
    </section>
  );
};

export default TrustedCompaniesSection;